<template>
  <el-container >
    <el-main>
      <el-row  justify="space-start" :gutter="20">
        
        <el-col :span="24">
          <el-card class="box-card">
            <h4 class="card-title">Existing Classrooms</h4>
            <div class="card-header">


              <div class="card-content">
                
                <el-row style="margin-top:30px; margin-bottom: 10px">
                  <el-col :span="12" style="">
                           <classroom-filter
                    :filter="classrooms"
                   
                    v-model="classrooms"
                    v-on:loading="loading = $event"
                    v-on:total="total = $event"
                    v-on:update:classrooms="classrooms = $event"
                  >
                          </classroom-filter>
                  </el-col>
             
                  <el-col :offset="4" :span="8" class="alignright">
                    <el-button type="primary" icon="el-icon-download" @click="classroomDownload()">Download CSV</el-button>
                    <router-link :to="'/classroom/create'">
                      <el-button type="success" icon="el-icon-plus">Create New Classroom</el-button>
                    </router-link>
                  </el-col>
                </el-row>
                <span v-if="total>0">Total: {{total}}</span>
                <div class="table-responsive">
                  <el-table
                    class="table-shopping"
                    style="width: 100%"
                    :data="classrooms"
                    :tool-bar="false"
                  :default-sort = "{prop: 'startDate', order: 'descending'}"
                    :total="total"
                    :loading="loading"
                    
                  >
                    <el-table-column type="expand">
                      <template slot-scope="props">
                        <el-col :span="24" :offset="1">
                          <i class="el-icon-loading" v-if="loading"></i>
                          <p v-if="props.row.tutor">
                            <strong>Tutor:</strong>
                            {{props.row.tutor.firstname}} {{props.row.tutor.lastname}} <router-link :to="'/tutors/edit/'+props.row.tutor.id">
                                <span class="ti-new-window"></span>
                              </router-link>
                          </p>
                          <p v-if="props.row.venue">
                            <strong>Venue:</strong>
                            {{props.row.venue.name}}, {{props.row.venue.line1}}, {{props.row.venue.town}} <router-link :to="'/classroom/venue/edit/'+props.row.venue.id">
                                <span class="ti-new-window"></span>
                              </router-link>
                            <br />
                          </p>
                          <p>
                            <strong>Attendees:</strong>
                            <br />
                            <el-tag
                              size="mini"
                              type="success"
                              v-for="(attendee,index) in props.row.attendees"
                              :key="index"
                            >
                              {{attendee.customer.firstname}} {{attendee.customer.lastname}}
                              <router-link :to="'/customer/edit/'+attendee.customer.id">
                                <span class="ti-new-window" style="color:#fff;"></span>
                              </router-link>
                            </el-tag>
                          </p>
                        </el-col>
                      </template>
                    </el-table-column>
                    <el-table-column label="Status" min-width="10">
                      <template slot-scope="props">
                        <span class="label label-danger" v-if="props.row.historic == '1' && props.row.isPublic == '0'">Cancelled</span>
                        <span class="label label-warning" v-if="props.row.historic != '1' && props.row.isPublic == '0'">Inactive</span>
                        <span class="label label-success" v-if="props.row.historic != '1' && props.row.isPublic == '1'">Active</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Code" min-width="10">
                      <template slot-scope="props"><span class="small">{{props.row.code}}</span></template>
                    </el-table-column>
                    <el-table-column label="Starts" min-width="10" prop="startDate" sortable>
                      <template slot-scope="props">{{props.row.startDate | moment('DD MMM YYYY')}}</template>
                    </el-table-column>
                    <el-table-column label="Ends" min-width="10" prop="endDate" sortable>
                      <template slot-scope="props">{{props.row.endDate | moment('DD MMM YYYY')}}</template>
                    </el-table-column>
                    <el-table-column label="Days" min-width="5">
                      <template slot-scope="props">{{props.row['length']}}</template>
                    </el-table-column>
                    <el-table-column label="Places" min-width="11" prop="numAttendees" sortable>
                      <template slot-scope="props">
                        <small
                          class="label label-info"
                          v-if="props.row.maxAttendees - props.row.numAttendees === 0"
                        >Fully booked!</small>
                        <small
                          class="label label-success"
                          v-if="props.row.maxAttendees - props.row.numAttendees <= 5 && props.row.maxAttendees - props.row.numAttendees > 0"
                        >{{props.row.maxAttendees - props.row.numAttendees}} remaining</small>
                        <small
                          class="label label-warning"
                          v-if="props.row.maxAttendees - props.row.numAttendees <= 10 && props.row.maxAttendees - props.row.numAttendees > 5"
                        >{{props.row.maxAttendees - props.row.numAttendees}} remaining</small>
                        <small
                          class="label label-danger"
                          v-if="props.row.maxAttendees - props.row.numAttendees > 10"
                        >{{props.row.maxAttendees - props.row.numAttendees}} remaining</small>
                      </template>
                    </el-table-column>

                    <el-table-column label="Venue" min-width="20">
                      <template slot-scope="props">{{props.row.venue.name}}</template>
                    </el-table-column>

                    <el-table-column label="Town" min-width="12">
                      <template slot-scope="props">{{props.row.venue.town}}</template>
                    </el-table-column>
           <el-table-column label="Tutor" min-width="13">
                      <template slot-scope="props"> <p v-if="props.row.tutor" class="small">{{props.row.tutor.firstname}} {{props.row.tutor.lastname}}</p><p class="small" v-else>no tutor</p></template>
                    </el-table-column>
                    <el-table-column min-width="5" label="Edit" class="td-text">
                      <template slot-scope="props">
                        <router-link :to="'/classroom/edit/' +props.row.id">Edit</router-link>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="card-content"></div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import ClassroomFilter from "../UIComponents/ClassroomFilter.vue";

import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";



export default {
  components: {
    ClassroomFilter
  },
  data() {
    return {
      countries: [],
      classrooms:[],
      total:0,
      aggregate: {},
      currentPage: 1,
      pageSize: 10,
      loading: false,
    };
  },
  methods: {
 
    classroomDownload() {
      this.csvArr = [];
      var classroom = this.classrooms;
      var sLen = this.classrooms.length;
      for (var i = 0; i < sLen; i++) {
        if(classroom[i].tutor){
          this.csvArr.push([
            classroom[i].code,
            classroom[i].startDate,
            classroom[i].endDate,
            classroom[i]['length'],
            classroom[i].maxAttendees - classroom[i].numAttendees,
            classroom[i].venue.name,
            classroom[i].venue.town,
            classroom[i].tutor.firstname + ' ' + classroom[i].tutor.lastname
          ]);
        } else {
          this.csvArr.push([
            classroom[i].code,
            classroom[i].startDate,
            classroom[i].endDate,
            classroom[i]['length'],
            classroom[i].maxAttendees - classroom[i].numAttendees,
            classroom[i].venue.name,
            classroom[i].venue.town,
            'None assigned'
          ]);  
        }
      }

      let csvContent =
        [
          [
            "Code",
            "Start Date",
            "End Date",
            "Days",
            "Places Remaining",
            "Venue Name",
            "Venue Location",
            "Tutor"
          ]
        ] + "\r";

      this.csvArr.forEach(rowArray => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });

      var fileURL = window.URL.createObjectURL(
        new Blob([csvContent], { type: "text/csv" })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "Classrooms.csv");
      document.body.appendChild(fileLink);
      fileLink.click();
    }
    
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Classrooms/List.vue